import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface IRecentSearchTileHeaderProps {
    title: string;
    inventoryCount: number;
    inventoryCountText: string;
    newMatchCountText?: string;
    isPartialRecentSearch?: boolean;
}

const RecentSearchTileHeader = ({
    title,
    newMatchCountText,
    inventoryCount,
    inventoryCountText,
    isPartialRecentSearch,
}: IRecentSearchTileHeaderProps) => (
    <Box
        component="figcaption"
        sx={{
            p: 3,
            pb: 0,
            minHeight: '5rem',
            // TODO : Update to background.subdued when available
            background: '#F2F3F5',
            zIndex: 1,
        }}
    >
        <Box>
            <Typography component="h6" variant="h6" color="secondary">
                {title}
            </Typography>
            <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center', height: '1.5rem' }}>
                <Typography
                    variant="body2"
                    component="span"
                    color={inventoryCount === 0 && !isPartialRecentSearch ? 'error' : 'textSecondary'}
                >
                    {inventoryCountText}
                </Typography>
                {newMatchCountText ? (
                    <Chip
                        size="small"
                        color="flagged"
                        aria-label={`${newMatchCountText} new matches.`}
                        label={newMatchCountText}
                        className="kmx-recent-search-tile-new-matches-chip"
                    />
                ) : null}
            </Stack>
        </Box>
    </Box>
);

export default RecentSearchTileHeader;
